export default {"src":"/_next/static/media/clear.f7f3dae3.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};